exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.donor-name[data-v-19b27bfb] {\n  font-family: 'Wittaya-Medium';\n  font-size: 1.1rem;\n}\n.remark[data-v-19b27bfb] {\n  font-family: 'Wittaya-Medium';\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19b27bfb","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/noomz/Projects/Opendream/kadnud/kadnud-eef-app/src/css"],"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DonorInfo.vue
// module id = 567
// module chunks = 1